export default {
  buttons: {
    verification: 'Xác thực',
    verification_now: 'Xác thực ngay',
    send: 'Gửi phản hồi',
  },

  common: {
    introduce: 'Giới thiệu',
    address: 'Địa chỉ',
    loading: 'Đang tải...',
    contact: 'Liên hệ',
    customer_name: 'Tên',
    content: 'Nội dung',
    congratulations: 'Xin chúc mừng',
    congratulations_content:
      ' Bạn đã mua được sản phẩm PISEN chính hãng. Xin vui lòng điền thông tin để kích hoạt bảo hành PISEN Care Plus từ 2-6 tháng ',
    email: 'Email',
    phone_number: 'Số điện thoại',
    verify_code: 'Mã xác thực',
    serial: 'Mã serial',
    error: 'Lỗi',
    success: 'Thành công',
    suggestion: 'Thư góp ý',
    home: 'Trang chủ',
    hotline: 'Liên hệ hotline: {phone}',
    warning: 'Cảnh báo',
    wellcome_title: 'RẤT VUI KHI BẠN ĐÃ QUAN TÂM VÀ SỬ DỤNG DỊCH VỤ CỦA CHÚNG TÔI! ',
    wellcome:
      'Chúng tôi tạo ra những điều hữu ích nhất giúp bạn có thể kiểm tra sản phẩm mua hàng để đảm bảo an toàn nhất. Bạn có thể chọn "Tra xuất thông tin sản phẩm" để tìm hiểu kỹ về thông tin sản phẩm hoặc xác thực sản phẩm chính hãng bằng cách chọn "Kiểm tra sản phẩm chính hãng" trên tay bạn ',
    info: 'Thông tin',
    not_found: 'Không tìm thấy',
    vetify_message:
      'Vui lòng nhập mã xác thực vào bên dưới. Sau đó ấn nút Xác Nhận để xác thực hàng hóa.',
    verification_product: 'Xác thực sản phẩm',
    check_product_info: 'Kiểm tra thông tin sản phẩm',
    note_verification: `<span class="text-[#B61212]">Lưu ý:</span> Nhập chính xác thông tin họ tên, SĐT để đảm bảo các quyền lợi về tích điểm, đổi quà và các vấn đề xác thực, khiếu nại liên quan.`,
    not_found_content:
      'Không có trên dữ liệu trên hệ thống. Vui lòng kiểm tra lại mã xác thực hoặc liên hệ hotline để được tư vấn. Xin cảm ơn!',
    error_content:
      'Có lỗi đã xảy ra. Vui lòng kiểm tra lại mã xác thực hoặc liên hệ hotline để được tư vấn. Xin cảm ơn!',
    message_content:
      'Vui lòng nhập mã xác thực vào bên dưới. Sau đó ấn nút Xác Nhận để xác thực hàng hóa.',
    limit_scan: 'Số lượng quét vượt quá giới hạn',
    limit_scan_content: 'Số lượng quét vượt quá giới hạn. Vui lòng liên hệ hotline để được hỗ trợ',
    stamp_new_title: 'Cảnh báo',
    stamp_new_content: 'Sản phẩm chưa được xuất kho. Vui lòng liên hệ hotline để được hỗ trợ.',
    stamp_blocked_title: 'Cảnh báo',
    stamp_blocked_content: 'Mã tem đang bị khoá. Vui lòng liên hệ hotline để được hỗ trợ.',
    stamp_verified:
      'Sản phẩm đã được xác thực trước đó. Vui lòng kiểm tra lại hoặc liên hệ với người bán để được hỗ trợ!',
    stamp_verify_success: 'Chúc mừng bạn! Đây là sản phẩm chính hãng. Xin cảm ơn quý khách!',
    stamp_warranty_replaced: 'Sản phẩm đã được thay thế bảo hành.',
    stamp_unsold_product: 'Cảnh báo sản phẩm chưa bán admin',
    stamp_is_being_processed: 'Tem đang xử lý',

    stamp_cannot_access_scan_stamp_title: 'Cảnh báo',
    stamp_cannot_access_scan_stamp_content:
      'Sản phẩm không được phép xác thực trên ứng dụng landing page. Vui lòng kiểm tra lại hoặc liên hệ với người bán để được hỗ trợ!',
    stamp_processing: 'Cảnh báo',
    stamp_processing_title: 'Cảnh báo',
    stamp_processing_content:
      'Sản phẩm đang đang trong quá trình xử lý. Vui lòng kiểm tra lại hoặc liên hệ với người bán để được hỗ trợ!',
    or: 'hoặc',
  },

  products: {
    title: 'Thông tin sản phẩm',
    detail: 'Chi tiết sản phẩm',
    name: 'Tên sản phẩm',
    brand: 'Thương hiệu',
    category: 'Danh mục',
    price: 'Giá',
    description: 'Mô tả',
  },

  placeholders: {
    customer_name: 'Nhập tên',
    phone_number: 'Nhập số điện thoại',
    email_address: 'Nhập email',
    content: 'Nhập nội dung',
    verify_code: 'Nhập mã xác thực',
    serial: 'Nhập mã serial',
  },

  validator: {
    content: 'Nội dung không được để trống',
    email: 'Email không đúng định dạng',
    required: '{name} không được để trống',
    max: '{name} không được phép vượt quá {number} ký tự',
    min: '{name} không được phép ít hơn {number} ký tự',
    noWhiteSpace: '{name} không được chứa khoảng trắng',
    phone: 'Số điện thoại không đúng định dạng',
    minPhoneNumber: 'Số điện thoại không được phép ít hơn {number} kí tự',
  },
  
  stamp_status: {
    checking: 'Đang kiểm tra',
    new: 'Tem mới',
    product_assigned: 'Đã gán sản phẩm',
    processing: 'Đang xử lý',
    sold: 'Đã bán',
    warranty_processing: 'Đang xử lý bảo hành',
    warranty_replaced: 'Đã thay bảo hành',
    activated: 'Đã kích hoạt',
    blocked: 'Đã bị chặn',
    not_enough_stamp: 'Không đủ tem',
    out_of_stamp: 'Hết tem',
    over_limited: 'Đã kích hoạt',
  }
};
